import { createStore } from 'redux';

const initialState = {
  userData: {
    userId: undefined,
    gerencia: undefined,
    cargo: undefined,
    token: undefined,
    logoURL: 'https://firebasestorage.googleapis.com/v0/b/confipetroldev.appspot.com/o/icons%2FSharedScreenshot.jpg?alt=media&token=f0cf7ecc-b4cf-4857-9f95-ca79315f75c7',
    codigoEmpresa: '537'
  },
  isLogged: false,
}

const actions = (state, action) => {
  if (state === undefined) {
    return initialState
  }
  switch (action.type) {
    case 'LOG_IN':
      return Object.assign({}, state, {
        userData: { ...action.userData },
        isLogged: true
      })
    default:
      return state
  }
}
const reducer = createStore(actions, initialState)

export default reducer